import Api from '../api';

export interface StrategicQuestion {
  id: string;
  topico: string;
  titulo: string;
  texto: string;
  resposta: string | null;
}

export interface StrategicQuestionsResponse {
  pendente: boolean;
  indisponivel: boolean;
  parcial: boolean;
  desatualizada: boolean;
  perguntas: StrategicQuestion[];
}

export const getStrategicQuestions = (biddingId: number) =>
  Api.get<StrategicQuestionsResponse>(`/gestao_ia/licitacoes/${biddingId}/perguntas_estrategicas`);
